import {
  type HeadlineResponsePagedData,
  v1CategoriesHeadlinesPaginatedDetail,
} from '@on3/api';
import { type ErrorData } from '@on3/ui-lib/api/schema/custom-contracts';
import { useSite } from '@on3/ui-lib/contexts/SiteProvider';
import { externalApi } from '@on3/ui-lib/utils/api';
import { MobileMPU } from '@public/components/Ads/MobileMPU';
import { MPU } from '@public/components/Ads/MPU';
import { ArticleLarge } from '@public/components/Headlines/ArticleLarge/ArticleLarge';
import { type AxiosError } from 'axios';
import React, { useCallback, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import styles from './ArticleList.module.scss';

export const ArticlesList = ({ list = [] }: HeadlineResponsePagedData) => {
  const [hasMore, setHasMore] = useState(true);
  const [feedData, setFeedData] = useState(list || []);
  const { currentSite } = useSite();
  const [page, setPage] = useState(2);

  const main = currentSite?.siteCategories?.find(
    (category) => category.url === '',
  );

  const fetchData = useCallback(async () => {
    try {
      const params = {
        page: page || 0,
        category: main?.categoryKey || 0,
      };

      const newData = await v1CategoriesHeadlinesPaginatedDetail(
        externalApi,
        params,
      );

      if (newData?.list && newData?.list?.length > 0) {
        setFeedData([...feedData, ...newData.list]);
        setPage(page + 1);
      } else {
        setHasMore(false);
      }
    } catch (e: unknown) {
      const { response, message }: AxiosError<ErrorData> =
        e as AxiosError<ErrorData>;

      console.error(
        'Load more issue on Feed Home: ',
        response?.data?.message || message,
      );
    }
  }, [feedData, main?.categoryKey, page]);

  if (feedData.length < 1) {
    return null;
  }

  return (
    <div className={styles.block}>
      <div className={styles.listDate}>
        <span className={styles.date}>
          {feedData[0]?.postDate?.split('T')[0]}
        </span>
      </div>
      <InfiniteScroll
        className={styles.largeArticleList}
        dataLength={feedData.length}
        hasMore={feedData?.length > 0 && hasMore}
        loader={<h4>Loading...</h4>} //TODO: replace with on3 spinner
        next={fetchData}
        scrollThreshold="800px"
      >
        {feedData.map((article, index) => {
          return (
            <React.Fragment key={article.key}>
              <ArticleLarge {...article} />
              {(index + 1) % 5 === 0 && index > 0 && (
                <div className={styles.ad}>
                  <MPU
                    className={styles.videoAd}
                    id={`mpu_inc-${(index + 1) / 5}`}
                    incontent
                  />
                  <MobileMPU
                    className={styles.videoAd}
                    id={`mobile_mpu_inc-${(index + 1) / 5}`}
                    incontent
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </InfiniteScroll>
    </div>
  );
};
